import { render } from "./AccountDeleteNotice.vue?vue&type=template&id=10076478&scoped=true&ts=true"
import script from "./AccountDeleteNotice.vue?vue&type=script&lang=ts"
export * from "./AccountDeleteNotice.vue?vue&type=script&lang=ts"

import "./AccountDeleteNotice.vue?vue&type=style&index=0&id=10076478&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10076478"]])